import { lightTheme } from '../../../themes';

export default {
  container: {
    minHeight: '600px',
    marginTop: '50px',
  },
  highlightCell: {
    backgroundColor: 'rgba(136, 127, 255, 0.1)',
    color: lightTheme.palette.color.blackSecondary,
  },
  alternative: {
    backgroundColor: lightTheme.palette.primary.main,
    color: lightTheme.palette.primary.contrastText,
  },
  selected: {
    backgroundColor: lightTheme.palette.color.greenSecondary,
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
  tableStyle: {
    backgroundColor: lightTheme.palette.color.white,
  },
  disabledCell: {
    backgroundColor: '#999',
  },
  deduct: {
    color: lightTheme.palette.color.red,
  },
  oldTransaction: {
    color: '#48baff',
  },
  details: {
    color: lightTheme.palette.color.link,
    fontWeight: 900,
    textDecoration: 'underline',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  detailWrapper: {
    padding: '20px',
    backgroundColor: lightTheme.palette.color.grayFourth,
    color: lightTheme.palette.color.blackSecondary,
    fontWeight: 900,
  },
};
